import { getFormFields, getTasks } from '../../services/APIService'

export const retrieveTasks = async ({ commit, dispatch }) => {
  const tasks = await getTasks()
  if (tasks.length < 0) return

  let fields = await dispatch('getTaskFields', tasks.map(task => task.fh))
  tasks.forEach((task, index) => {
      task.field = fields[index]
    }
  )
  commit('SET_TASKS', tasks)
}

export const getTaskFields = async ({ commit, rootState }, fhList) => {
  return getFormFields(fhList, rootState.parantion.user.user.uh)
}
